<template>
    <div class="publication__cards content-width d-flex">
        <div class="publication__card d-flex"
             :class="{'publication__card--selected': selected === _item.key}" v-for="(_item, _idx) in initial">

            <div class="publication__card-left">
                <div class="publication__card-header  d-flex">
                    <img :src="_item.icon" class="publication__card-icon" alt="" v-if="_item.icon">
                    <h3 class="publication__card-title">{{$store.getters.t(_item.title)}}</h3>
                </div>

                <div class="publication__card-description">{{$store.getters.t(_item.description)}}</div>
            </div>
            <div class="publication__card-right d-flex">
                <a :href="_item.link" class="btn publication__btn" v-if="_item.link">{{$store.getters.t('common_choose')}}</a>
                <a href="#" class="btn publication__btn" v-if="selected !== _item.key"
                   @click.prevent="$v.selected.$model = _item.key;"
                   >{{$store.getters.t('common_choose')}}</a>
                <a href="#" @click.prevent="$v.selected.$model = null"
                   class="btn publication__btn publication__btn--selected" v-if="selected === _item.key">{{$store.getters.t('common_cancel')}}</a>
            </div>

        </div>

        <div class="text-danger" v-if="$v.selected.$error" >{{$store.getters.t('publication_pet_create_select_ad_type')}}</div>

    </div>
</template>

<script>


const createPetVerify = {
    device: {
        key: 'device', title: 'publication_pet_create_title_device',
        description: 'publication_pet_create_desc_device',
    },
    fundraising: {
        key: 'fundraising', title: 'publication_pet_create_title_fundraising',
        description: 'publication_pet_create_desc_fundraising',
    },
};

import { required } from 'vuelidate/lib/validators';
import StateMixin from "../mixins/StateMixin";

export default {
    name: "PublicationCreatePet",
    props: ['server'],
    mixins: [StateMixin],
    computed: {

        initial() { return createPetVerify },

        selected: {
            get() { return this.GET_BY_KEY('create_category') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'create_category', data: val})
            }
        }

    },

    methods:{
        isValid(){
            this.$v.$touch();

            if( this.$v.$invalid ){
                this.$emit('parent-update', false );
                return  false
            }

            this.$emit('parent-update', true )
            return  true
        }

    },

    validations: { selected: { required } }

}
</script>

<style scoped>

</style>
